import React, {Component} from 'react';
import {debounce} from '../../../helpers/debounce';
import ReactTable from 'react-table';

import {Alert, Button, Card, CardBody, CardTitle, Col, FormGroup, Input, Row,} from 'reactstrap';

import {connect} from 'react-redux';
import {closeAlert} from '../../../actions/commonsActions';
import {API_BASE_URL, PAGINATION_DEFAULT_LIMIT, SUPER_ADMIN, USER_ROLES,} from '../../../helpers/constants';
import Pagination from '../../Pagination/Pagination';
import {I18n} from "../../../I18n/components/statistics";
// Datetime picker plugin file
import Datetime from "react-datetime";
import 'react-datetime/css/react-datetime.css';

import 'react-table/react-table.css';
import './apps-stat.css';
import moment from "moment";
import {push} from "connected-react-router";
import {fetchCompanies} from "../../../actions/companyActions";
import {fetchStores} from "../../../actions/storesActions";
import {fetchAppsStats, fetchCompanyStats, filteringCompanyStats} from "../../../actions/statsActions";
import noImg from '../../../assets/images/img-error.svg';
import swal from 'sweetalert'
import {isStatisticPermission} from "../../../helpers/companyService";

class AppsStat extends Component {
	constructor(props) {
		super(props);
		this.state = {
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
			companyId: '',
			salesPointId: '',
			filters: [],
			sorting: false,
			currentPage: 0,
		};
		this.debounceFetch = debounce(this.fetchPaginatedData, 500);
	}

	componentDidMount() {
		if (!isStatisticPermission(this.props.companies[0], this.props.authority)) {
			swal(
				I18n[this.props.lang].general.contactUsToAccessThis,
				"",
				"error")
			return
		}
		const companyId = this.props.match && this.props.match.params && this.props.match.params.companyid ?
			this.props.match.params.companyid : null;
		const urlParams = new URLSearchParams(window.location.search);
		const dateFrom = urlParams.has('dateFrom') ?
			urlParams.get('dateFrom') : moment(1, 'DD').format('YYYY-MM-DD');
		const dateTo = urlParams.has('dateTo') ?
			urlParams.get('dateTo') : moment().format('YYYY-MM-DD');
		const salesPointId = urlParams.has('storeId') ? urlParams.get('storeId') : null;

		this.setState({
			dateFrom : dateFrom ? dateFrom : null,
			dateTo: dateTo ? dateTo : null,
			salesPointId: salesPointId ? salesPointId : '',
			companyId: companyId ? companyId : (
				this.props.authority !== SUPER_ADMIN ? this.props.companies[0].id : '')
		}, () => {
			const filters = [
				{name: 'salesPointId', value: this.state.salesPointId},
				{name: 'dateFrom', value: this.state.dateFrom},
				{name: 'dateTo',  value: this.state.dateTo},
				{name: 'companyId',  value: this.state.companyId}
			];
            const storesQuery = {
            	limit: 100000,
			};
            if (this.state.companyId) {
				storesQuery.companyId = this.state.companyId
			}
			this.props.fetchStores(storesQuery).then(() => {
				this.props.fetchAppsStats( {
					filters
				});
			})
		});
	}

	fetchPaginatedData = async currentPage => {
		const filters = this.props.authority !== SUPER_ADMIN ? (
			[
				{name: 'companyId', value: this.state.companyId},
				{name: 'dateFrom', value: this.state.dateFrom},
				{name: 'dateTo',  value: this.state.dateTo},
				...this.state.filters.length ? this.state.filters : false,
			]
		) : (
			[
				{name: 'dateFrom', value: this.state.dateFrom},
				{name: 'dateTo',  value: this.state.dateTo},
				...this.state.filters.length ? this.state.filters : false,
			]
		);
		await this.props.fetchAppsStats({
			filters,
			sorting: this.state.sorting ? this.state.sorting : false,
			page: currentPage
		});
		await this.setState({
			currentPage,
			// sortState: this.state.sorting ? this.state.sorting : {
			// 	id: 'name',
			// 	desc: true
			// }
		});
	};

	setCurrentPage = async currentPage => {
		this.setState({
			currentPage
		}, () => {
			this.fetchPaginatedData(currentPage)
		});
	};

	onFilterClick = (name, value) => {
		this.setState(state => {
			const filteredElemIndex = state.filters.findIndex(item => item.name === name);
			let filters = [...state.filters];
			if (filteredElemIndex !== -1) {
				if (value && value !== '') {
					filters[filteredElemIndex].name = name;
					filters[filteredElemIndex].value = value;
				} else {
					filters = filters.filter(elem => elem.name !== name);
				}
			} else {
				filters = [...state.filters, {name : name, value: value}]
			}
			return {
				[`${name}`]: value,
				filters: filters
			}
		})
		// 	() => {
		// 	this.fetchPaginatedData(0);
		// })
		this.debounceFetch(0)
	};

	dateToTimeChange = moment => {
		this.setState({
			dateTo: moment.format('YYYY-MM-DD')
		}, () => {
			this.fetchPaginatedData(0);
		})
	};

	dateFromTimeChange = moment => {
		this.setState({
			dateFrom: moment.format('YYYY-MM-DD')
		}, () =>{
			this.fetchPaginatedData(0);
		})
	};

	clearFilters = () => {
		this.setState({
			dateFrom: moment(1, 'DD').format('YYYY-MM-DD'),
			dateTo: moment().format('YYYY-MM-DD'),
			companyId: this.props.authority === SUPER_ADMIN ? '' : this.state.companyId,
			salesPointId: '',
			filters: [],
			sorting: false,
			//order: 'ASC',
		}, () =>{
			this.fetchPaginatedData(0);
		})
	};

	getFiltered = async () => {
		this.fetchPaginatedData(0);
	};

	render() {
		const {lang} = this.props;
		console.log('props', this.props);
		console.log('state', this.state);
		return (
			<div className='apps-stats'>
				{/*----------------------- alerts -----------------------------------*/}
				<Alert
					color={`${this.props.alert.alert.status}`}
					isOpen={this.props.alert.isOpen || false}
				>
					{this.props.alert.isOpen ? `${this.props.alert.alert.message}` || "Failed": ''}
				</Alert>
				<Card>
					<CardTitle className="mb-0 p-3 border-bottom bg-light">
						<div>
							<i className="mdi mdi-border-right mr-2"></i>{I18n[lang].apps.title}
						</div>
					</CardTitle>

					<CardBody>
						<Row>
							<Col lg="12">
								<FormGroup>
									<Input
										className="apps-search-filter"
										type="text"
										name="search"
										id="search"
										value={this.state.name}
										onChange={(e) =>
											this.onFilterClick('name', e.target.value)}
										placeholder={I18n[lang].apps.placeholder}
									/>
									{
										this.props.authority === SUPER_ADMIN ? (
											<Input
												className="apps-company-filter"
												type="select"
												name="companyId"
												id="companyId"
												onChange={(e) =>
													this.onFilterClick('companyId', e.target.value)}
												value={this.state.companyId}
											>
												<option value="">{I18n[lang].apps.company}</option>
												<option value="">{I18n[lang].apps.all}</option>
												{
													this.props.companies ? (
														this.props.companies.map((company, i) => {
															return (
																<option value={company.id} key={i}>{company.name}</option>
															)
														})
													) : (
														<option value="">{I18n[lang].apps.all}</option>
													)
												}
											</Input>
										) : null
									}
									{
										<Input
											className="apps-salespoint-filter"
											type="select"
											name="salesPointId"
											id="salesPointId"
											onChange={(e) =>
												this.onFilterClick('salesPointId', e.target.value)}
											value={this.state.salesPointId}
										>
											<option value="">{I18n[lang].apps.salesPoint}</option>
											<option value="">{I18n[lang].apps.all}</option>
											{
												this.props.stores ? (
													this.props.stores.map((store, i) => {
														return (
															<option value={store.id} key={i}>{store.name}</option>
														)
													})
												) : (
													<option value="">{I18n[lang].apps.all}</option>
												)
											}
										</Input>
									}

									<Datetime
										className="apps-data-filter"
										locale="en-gb"
										timeFormat={false}
										closeOnSelect={true}
										onChange={this.dateFromTimeChange}
										inputProps={{ placeholder: `${I18n[lang].apps.dateFrom}`, readOnly:true }}
										value={this.state.dateFrom ?
											moment(this.state.dateFrom).format('DD.MM.YYYY') :
											moment(1, 'DD').format('YYYY-MM-DD')}
									/>
									<Datetime
										className="apps-data-filter date-to"
										locale="en-gb"
										timeFormat={false}
										closeOnSelect={true}
										onChange={this.dateToTimeChange}
										inputProps={{ placeholder: `${I18n[lang].apps.dateTo}`, readOnly:true }}
										value={this.state.dateTo ?
											moment(this.state.dateTo).format('DD.MM.YYYY') :
											moment().format('YYYY-MM-DD')}
									/>
									<div className="company-btn__group">
										{/*<Button*/}
										{/*	color="primary"*/}
										{/*	type="button"*/}
										{/*	className="company-btn btn-filter"*/}
										{/*	onClick={this.getFiltered}*/}
										{/*>*/}
										{/*	{I18n[lang].point.filter}*/}
										{/*</Button>*/}
										<Button
											color="primary"
											type="button"
											className="company-btn btn-clear"
											onClick={this.clearFilters}
										>
											{I18n[lang].apps.resetFilter}
										</Button>
									</div>
								</FormGroup>
							</Col>
						</Row>
						{
							(() => {
								if (this.props.statsLoading) {
									return <div className="loading">Loading...</div>;
								} else {
									const apps = (this.props.stats && this.props.stats.byAppsReportDtos)
										|| [];
									let firstElementNumber = this.state.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
									const tableData = apps.map(app => {
										return {
											count_id: firstElementNumber++,
											id: app.packageName,
											name: {
												packageName: app.packageName,
												name: app.appName
											},
											packages: app.bundlesCount,
											quantity: app.appsCount,
											app: app
										};
									});
									return (
										<div>
											<div className="stat-table">
												<ReactTable
													getProps={() => {
														return {
															style: {
																border: "none",
																padding: "5px"
															}
														};
													}}
													getTheadProps={() => {
														return {
															style: {
																boxShadow: "none",
																padding: "10px 0",
																fontWeight: "600"
															}
														};
													}}
													getTheadThProps={() => {
														return {
															style: {
																borderRight: "none"
															}
														};
													}}
													getTdProps={() => {
														return {
															style: {
																borderRight: "none",
																textAlign: "center"
															}
														};
													}}
													getTrProps={() => {
														return {
															style: {
																alignItems: "center"
															}
														};
													}}
													getNoDataProps={() => {
														return {
															style: {
																top: "100%"
															}
														};
													}}
													columns={[
														{
															Header: "#",
															accessor: "count_id",
															sortable: false,
															filterable: false,
															style: {
																textAlign: "left",
																fontSize: "0.7rem",
																textTransform: "lowercase"
															},
															maxWidth: 40,
														},
														{
															Header: `${I18n[lang].apps.app}`,
															accessor: "name",
															sortable: false,
															filterable: false,
															minWidth: 200,
															style: {
																textAlign: "left"
															},
															Cell: row => (
																<div className="app-table__img">
																	<img
																		src={`${API_BASE_URL}/apps/mobileapps/download/icon?packageName=${row.value.packageName}`}
																		alt="application logotype"
																		className="img-fluid media-object"
																		width="30"
																		onError={(e) => {
																			e.target.onerror = null;
																			e.target.src = noImg
																		}}
																	/>
																	<span>{row.value.name}</span>
																</div>
															)
														},
														// {
														// 	Header: `${I18n[lang].apps.packs}`,
														// 	accessor: "packages",
														// 	sortable: false,
														// 	filterable: false,
														// 	maxWidth: 110,
														// 	style: {
														// 		fontSize: "0.7rem",
														// 		textAlign: "center"
														// 	},
														// },
														{
															Header: `${I18n[lang].apps.numbers}`,
															accessor: "quantity",
															sortable: false,
															filterable: false,
															maxWidth: 200,
															style: {
																fontSize: "0.7rem",
																textAlign: "center",
																whiteSpace: "pre-line"
															},
														},
													]}
													PaginationComponent={Pagination}
													nextText={">>"}
													previousText={"<<"}
													defaultPageSize={-1}
													pageSize={tableData.length}
													// showPaginationBottom={false}
													showPaginationBottom={this.props.pagination.totalPages > 1}
													className="-highlight"
													data={tableData}
													filterable
													// custom paginator settings
													manual
													onPageChange={this.setCurrentPage}
													page={this.state.currentPage}
													pages={this.props.pagination.totalPages}
												/>
											</div>
										</div>
									)
								}
							})()
						}
					</CardBody>
				</Card>
			</div>
		)
	}
}

const mapDispatchToProps = dispatch => {
	return {
		closeAlert: () => dispatch(closeAlert()),
		changeLocation: (url) => dispatch(push(url)),
		fetchCompanies: (query) => dispatch(fetchCompanies(query)),
		fetchStores: (query) => dispatch(fetchStores(query)),
		fetchAppsStats: (query) => dispatch(fetchAppsStats(query)),
		fetchCompanyStats: (companyId, query) => dispatch(fetchCompanyStats(companyId, query)),
		filteringCompanyStats: word => dispatch(filteringCompanyStats(word)),
	};
};

const mapStateToProps = state => ({
	alert: state.alert,
	companies: state.companiesReducer.companies,
	stores: state.storesReducer.stores,
	authority:  state.currentUser.roles[0].authority || USER_ROLES.GUEST,
	lang: state.languageReducer.lang,
	stats: state.appsStatsReducer.appsStats,
	pagination: state.appsStatsReducer.pagination,
	statsLoading: state.appsStatsReducer.loading,
	companyLoading: state.companyStatsReducer.loading,
});

export default connect(mapStateToProps, mapDispatchToProps)(AppsStat);



// WEBPACK FOOTER //
// ./src/components/Statistics/AppsStat/AppsStat.js